// extracted by mini-css-extract-plugin
export default {"actions":"ProgramsTable_actions__eLu74"};